<template>
    <div class="specailPage">
        <vheader :type="tabType" :current="currentIndex"></vheader>
        <div class="wn_banner"></div>
            <div class="wn_bigdiv2">
                <div class="wn_div1200">
                    <div class="div1">
                        <div class="div1title">
                            <p><img src="@/assets/images/specailPage/title_line.png"></p>
                            <h3>过年不喝假酒</h3>
                            <h6>-扫码验真 一点即购-</h6>
                        </div>
                        <div class="div1body">
                            <h5 class="div1body_h51">活动目的：</h5>
                            <p>酒在中国有着悠久的酝酿历史，醇厚的口感深得广大消费者的追求。过节送礼、婚宴喜宴，酒都是送礼、助兴的必备产品之一。市场上假酒泛滥，不仅损害企业利益，更严重危害消费者的的身心健康。直购易是依托构信网（公信.中国）的权威数据信息，丰富流量入口、顶级中文域名（.购物）入口的新零售平台，为消费者提供可信的购买入口，形成商业闭环。</p>
                            <p>构信网（公信.中国）是依据国家指导政策的平台，千万级企业信息快速搜索、工商信息、失信记录等多维度聚合，打造公正、权威的信息查询平台，为广大网名提供信息查询服务！入驻直购易，赋能公信价值，增加企业的可信度，为诚信加分。</p>
                            <h5 class="div1body_h52">活动时间：</h5>
                            <p>2018年10月——2019年2月</p>
                        </div>
                    </div>
                    <div class="div2">
                <div class="div2title">
                    <p><img src="@/assets/images/specailPage/title_line.png"></p>
                    <h3>公信直购易酒商展示区</h3>
                    <h6>-厂商直销 溯源正品-</h6>
                </div>
                <div class="div2body">
                    <div class="div2table">
                        <table>
                            <tr>
                                <th class="td_l" width="40%">推荐酒商</th>
                                <th class="td_r" width="40%">推荐产品</th>
                            </tr>
                            <tr v-for="(item, index) in proList" :key="index">
                                <td class="td_l">{{item.sellerName}}</td>
                                <td class="td_r">{{item.proDescription}}</td>
                            </tr>
                        </table>
                    </div>
                    <div class="page_box clearfix tac">
                        <el-pagination
                          class="pages"
                          background
                          :page-size="limit"
                          :current-page="currentPage"
                          @current-change="_pagechange"
                          :total="total">
                        </el-pagination>
                    </div>
                    <div class="div2_line1">
                        <img src="@/assets/images/specailPage/div2_tip1.png" alt="联系我们">
                        <img src="@/assets/images/specailPage/div2_tipline.png" class="div2_tipline">
                        <img src="@/assets/images/specailPage/div2_tip2.png" alt="签订合同">
                        <img src="@/assets/images/specailPage/div2_tipline.png" class="div2_tipline">
                        <img src="@/assets/images/specailPage/div2_tip3.png" alt="缴纳费用">
                    </div>
                    <div class="div2_next">
                        <img src="@/assets/images/specailPage/div2_tipline2.png">
                    </div>
                    <div class="div2_line2">
                        <img src="@/assets/images/specailPage/div2_tip6.png" alt="开通服务">
                        <img src="@/assets/images/specailPage/div2_tipline.png" class="div2_tipline">
                        <img src="@/assets/images/specailPage/div2_tip5.png" alt="客服审核">
                        <img src="@/assets/images/specailPage/div2_tipline.png" class="div2_tipline">
                        <img src="@/assets/images/specailPage/div2_tip4.png" alt="提供材料">
                    </div>
                </div>
            </div>
                    <div class="div3">
                        <img src="@/assets/images/specailPage/div3.jpg">
                    </div>
                    <div class="div4">
                        <div class="div4_200 div4_200_mr">
                            <img src="@/assets/images/specailPage/div3_1.png" alt="">
                            <p><span>01</span> <span>下载构信网（公信.中国）app</span></p>
                        </div>
                        <div class="div4_200 div4_200_mr">
                            <img src="@/assets/images/specailPage/div3_2.png" alt="">
                            <p><span>02</span> <span>打开扫码按钮</span></p>
                        </div>
                        <div class="div4_200 div4_200_mr">
                            <img src="@/assets/images/specailPage/div3_3.png" alt="">
                            <p><span>03</span> <span>扫码识别条形码</span></p>
                        </div>
                        <div class="div4_200 div4_200_mr">
                            <img src="@/assets/images/specailPage/div3_4.png" alt="">
                            <p><span>04</span> <span>厂商商品特殊标识</span></p>
                        </div>
                        <div class="div4_200">
                            <img src="@/assets/images/specailPage/div3_5.png" alt="">
                            <p><span>05</span> <span>直购易</span></p>
                        </div>
                    </div>
                </div>
                <div class="applyform_box">
                    <apply-form class="w"></apply-form>
                </div>
            </div>
        <vfooter :btnShow="false"></vfooter>
        <loading v-show="loadingFlag"></loading>
    </div>
</template>

<script>
    import applyForm from '@/components/applyForm/ApplyForm'
    import vfooter from '@/components/footer/Footer'
    import vheader from '@/components/header/Header'
    import Loading from '@/components/loading/Loading'
    import { getToken, getSellerInfo } from '@/request/api'
    import { Pagination } from 'element-ui'
    export default {
        name: 'specailPage',
        metaInfo () {
            return {
                title: '直购易-新零售解决方案-企业服务',
                meta: [
                    {
                        name: 'keyWords',
                        content: '直购易、零售业解决方案、零售行业解决方案、新零售解决方案、零售转型、零售业数字化转型、新零售行业、新零售系统、智能新零售'
                    },
                    {
                        name: 'description',
                        content: '直购易新零售是依托构信网（公信.中国）大数据，区块链技术打造的零售新物种，为企业提供全方位的零售生态改造升级方案，通过品牌、技术、流量入口、营销等各环节赋能，开辟信用时代的新零售模式'
                }]
            }
        },
        data () {
            return {
                currentIndex: 7,
                loadingFlag: false,
                start: '0',
                tabType: '2',
                limit: 15,
                total: 10,
                currentPage: 1,
                headerType: '2',
                proList: []
            }
        },
        created() {
            this._getSellerInfo()
        },
        mounted() {
        },
        methods: {
            _getSellerInfo() {
                let that = this
                that.loadingFlag = true
                getToken().then(r => {
                    let params = {
                        start: this.start,
                        limit: this.limit
                    }
                    getSellerInfo(params, r.data).then(res => {
                        this.proList = res.data.list
                        this.total = parseInt(res.data.count)
                        this.loadingFlag = false
                    })
                })
            },
            _pagechange(page) {
                this.currentPage = page
                this.start = parseInt(page - 1) * this.limit
                this._getSellerInfo()
            }
        },
        components: {
            vheader,
            vfooter,
            Loading,
            applyForm,
            'el-pagination': Pagination
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped type="text/less" lang="less">
    .specailPage {
        background: url('../../assets/images/specailPage/bg.png') no-repeat;
        background-size: 100% 100%;
        .wn_banner {
            width: 100%;
            height: 717px;
            background: url('../../assets/images/specailPage/banner.png') no-repeat center top;
        }

        .wn_div1200 {
            width: 1200px;
            margin: 0 auto;
        }

        .div1,
        .div2,
        .div3,
        .div4,
        .div5 {
            padding: 32px 0;
        }

        .div1title,
        .div2title {
            text-align: center;
        }

        .div1title h3,
        .div2title h3 {
            font-family: WenYue-XinQingNianTi-NC-W8;
            font-size: 60px;
            color: #384775;
        }

        .div1title h6,
        .div2title h6 {
            font-size: 22px;
            color: #444c73;
            margin-top: 23px;
        }

        .div1body {
            color: #444c73;
            padding: 0 55px 0 100px;
        }

        .div1body h5 {
            font-size: 24px;
            font-weight: normal;
            letter-spacing: 4px;
            margin-bottom: 25px;
            position: relative;
            line-height: 59px;
            margin-top: 89px;
        }

        .div1body p {
            font-size: 18px;
            line-height: 30px;
        }

        .div1body_h51:after {
            content: " ";
            display: block;
            width: 58px;
            height: 59px;
            position: absolute;
            top: 0;
            left: -100px;
            z-index: 0;
            background: url('../../assets/images/specailPage/div1_blue.png') no-repeat;
        }

        .div1body_h52:after {
            content: " ";
            display: block;
            width: 58px;
            height: 59px;
            position: absolute;
            top: 0;
            left: -100px;
            z-index: 0;
            background: url('../../assets/images/specailPage/div1_red.png') no-repeat;
        }

        .div2body {
            padding: 80px 0 0;
        }

        .div2flex {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            margin-bottom: 50px;
        }

        .div2flex a {
            display: inline-block;
            width: 280px;
            height: 152px;
            margin-top: 50px;
            position: relative;
            text-align: center;
            transition: all 0.5s;
        }

        .div2flex_txt {
            font-size: 20px;
            color: #444c73;
            margin-top: 80px;
        }

        .div2flex_cicle {
            position: absolute;
            top: -60px;
            left: 50%;
            margin-left: -60px;
            width: 120px;
            height: 120px;
            border-radius: 50%;
            background: #ffffff;
            transition: all 0.5s;
        }

        .div2flex_cicle img {
            margin: 10px;
        }

        .div2flex a:hover {
            background-color: #ffffff;
            box-shadow: -4px 0px 38px 0px #ecf3ff;
        }

        .div2flex a:hover .div2flex_cicle {
            box-shadow: 0 -14px 38px 0px #ecf3ff;
        }

        .div2_line1,
        .div2_line2 {
            text-align: center;
        }

        .div2_next {
            text-align: right;
            padding-right: 225px;
            margin: 20px 0;
        }

        .div2_tipline {
            margin: 78px 28px;
        }

        .div3 {
            box-sizing: border-box;
        }

        .div3 img {
            width: 100%;
            box-shadow: -4px 0px 40px 0px #ecf4ff;
        }

        .div4 {
            *zoom: 1;
        }

        .div4:after {
            content: '';
            display: block;
            clear: both;
            height: 0px;
        }

        .div4_200 {
            width: 200px;
            float: left;
            box-sizing: border-box;
            text-align: center;
        }

        .div4_200_mr {
            margin-right: 50px;
        }

        .div4_200 img {
            width: 100%;
            height: 347px;
        }

        .div4_200 p {
            color: #444c73;
            font-size: 16px;
            margin-top: 45px;
            z-index: 2;
        }

        .div4_200 p span {
            position: relative;
            z-index: 2;
        }

        .div4_200 p span:nth-of-type(1) {
            color: #5b79fb;
            font-size: 35px;
            position: relative;
            z-index: 2;
        }

        .div4_200 span:nth-of-type(1):after {
            content: "";
            display: block;
            width: 44px;
            height: 46px;
            position: absolute;
            top: 0;
            left: 12px;
            z-index: -1;
            background: url('../../assets/images/specailPage/div3_bg.png') no-repeat;
        }
        .div5_form {
            margin-left: 320px;
            width: 880px;
        }

        .div5_form>ul {
            list-style: none;
            margin-top: 50px;
            width: 600px;
            margin-left: 200px;
        }

        .div5_form>ul li {
            height: 45px;
            margin-bottom: 15px;
            width: 100%;
        }

        .div5_form>ul li label {
            display: inline-block;
            float: left;
            height: 45px;
            line-height: 45px;
        }

        .label_l {
            text-align: right;
            font-size: 16px;
            color: #666666;
            width: 105px;
        }

        .label_r {
            text-align: left;
            margin-left: 23px;
            position: relative;
        }

        .label_r>input {
            width: 460px;
            height: 45px;
            border-radius: 3px;
            border: solid 1px #d2d2d2;
            padding-left: 22px;
            box-sizing: border-box;
            color: #666666;
        }

        .label_r>input:focus {
            border: solid 1px #2d68e7;
        }

        .label_r div input {
            line-height: 45px;
            width: 220px;
            height: 45px;
            border: solid 1px #d2d2d2;
            border-radius: 3px;
            float: left;
            position: relative;
            text-align: center;
            box-sizing: border-box;
        }

        .label_r div ul {
            display: none;
            position: absolute;
            top: 46px;
            left: 0;
            width: 100%;
            list-style: none;
            height: 190px;
            background-color: #ffffff;
            border-radius: 3px;
            border: solid 1px #d2d2d2;
            overflow-y: scroll;
            box-sizing: border-box;
        }

        .label_r div input:first-child {
            margin-right: 19px;
        }

        .label_r div img {
            width: 11px;
            height: 7px;
            position: absolute;
            right: 15px;
            top: 45%;
            cursor: pointer;
        }

        .label_r div ul li {
            color: #666666;
            font-size: 14px;
            text-align: center;
            line-height: 45px;
            height: 45px;
            cursor: pointer;
        }

        .label_r div ul li:hover {
            background-color: #f3f2f2;
        }

        .err_input {
            border: solid 1px #ff0000 !important;
        }

        .err_tip {
            position: absolute;
            top: 0;
            left: 23px;
            height: 45px;
            line-height: 45px;
            color: #ff0000;
            display: none;
        }

        .div2table table {
            width: 100%;
            border-collapse: collapse;
            box-sizing: border-box;
            table-layout: fixed;
            margin-bottom: 23px;
        }

        .div2table table tr th {
            font-family: MicrosoftYaHei-Bold;
            font-size: 18px;
            color: #333333;
            height: 76px;
            line-height: 76px;
            font-weight: bold;
            border: 1px solid #ededed;
            &.td_l{
                border-top: 1px solid #e64646;
            }
            &.td_r{
                border-top: 1px solid #2968e8;
            }
        }

        .div2table table tr {
            width: 1200px;
        }

        .div2table table tr td {
            line-height: 18px;
            font-size: 14px;
            color: #000000;
            border: 1px solid #ededed;
            padding: 16px 18px;
            &.td_r{
                // text-align: left;
            }
        }

        .div2table table tr td:nth-of-type(1) {
            width: 40%;
        }
        .applyform_box{
            padding-top: 70px;
            padding-bottom: 135px;
        }
        .page_box{
            padding-top: 20px;
            padding-bottom: 60px;
            .pages{
                display: inline-block;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/specialPage/SpecialPage.vue